import React from 'react';
import { Mail, Globe, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 py-16 px-4 sm:px-6 lg:px-8 border-t border-slate-800" data-id="element-121">
      <div className="max-w-5xl mx-auto text-center" data-id="element-122">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-900 border border-slate-800 mb-8" data-id="element-123">
          <span className="font-bold text-blue-400" data-id="element-124">PACKVIAJERO™</span>
        </div>

        <p className="text-xl text-white font-bold mb-4" data-id="element-125">
          El sistema N°1 para el viajero argentino que va al exterior sin saber
          inglés.
        </p>
        <p className="text-slate-400 mb-12 max-w-2xl mx-auto" data-id="element-126">
          Porque viajar a Londres no debería costarte el disfrute de cada
          momento por no entender el idioma.
        </p>

        <div className="flex flex-wrap justify-center gap-6 md:gap-10 mb-12" data-id="element-127">
          <a href="mailto:soporte@supportrainingpro.com" className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors" data-id="element-128">
            <Mail className="w-5 h-5" data-id="element-129" /> soporte@supportrainingpro.com
          </a>
          <a href="#" className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors" data-id="element-130">
            <Instagram className="w-5 h-5" data-id="element-131" /> @packviajero
          </a>
          <a href="https://www.supportrainingpro.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors" data-id="element-132">
            <Globe className="w-5 h-5" data-id="element-133" /> www.supportrainingpro.com
          </a>
        </div>

        <div className="pt-8 border-t border-slate-800/50 text-sm text-slate-500 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-134">
          <p data-id="element-135">© PackViajero™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-136">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-137">Powered by SupportTrainingPro™</p>
        </div>

        <div className="mt-8 text-slate-600 italic" data-id="element-138">
          🇬🇧 "El próximo viaje puede ser completamente diferente."
        </div>
      </div>
    </footer>;
}